(() => {
  const section = document.getElementById('parallaxGallery');
  if (!section) return;

  const layer = section.querySelector('#wsParallaxLayer');
  if (!layer) return;

  const items = Array.from(layer.querySelectorAll('.ws-parallax-item'));
  if (!items.length) return;

  // const isMobile = () => window.innerWidth < 769;

  // Wrap each img in a parallax-move div so mouse transform never
  // conflicts with the CSS hover transform on the item itself
  items.forEach(item => {
    const img = item.querySelector('.ws-parallax-img');
    if (!img) return;
    if (!item.querySelector('.ws-parallax-img-wrap')) {
      const wrap = document.createElement('div');
      wrap.className = 'ws-parallax-img-wrap';
      item.insertBefore(wrap, img);
      wrap.appendChild(img);
    }
  });

  // Per-item lerp state
  const data = items.map(item => ({
    el: item,
    depth: parseFloat(item.dataset.depth) || 1,
    current: { x: 0, y: 0 },
    target: { x: 0, y: 0 }
  }));

  const sensitivity = -1;
  const easing = 0.05;
  let mousePos = { x: 0, y: 0 };
  let rafId = null;
  let isVisible = false;

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function tick() {
    if (!isVisible) { rafId = null; return; }

    let stillMoving = false;
    data.forEach(d => {
      const tx = mousePos.x * (d.depth * sensitivity / 20);
      const ty = mousePos.y * (d.depth * sensitivity / 20);

      d.current.x = lerp(d.current.x, tx, easing);
      d.current.y = lerp(d.current.y, ty, easing);

      const wrap = d.el.querySelector('.ws-parallax-img-wrap');
      if (wrap) {
        wrap.style.transform = `translate3d(${d.current.x}px, ${d.current.y}px, 0)`;
      }

      if (Math.abs(d.current.x - tx) > 0.01 || Math.abs(d.current.y - ty) > 0.01) {
        stillMoving = true;
      }
    });

    rafId = stillMoving ? requestAnimationFrame(tick) : null;
  }

  function startRaf() {
    if (!rafId) rafId = requestAnimationFrame(tick);
  }

  section.addEventListener('mousemove', e => {
    // if (isMobile()) return;
    const rect = section.getBoundingClientRect();
    mousePos.x = e.clientX - rect.left - rect.width / 2;
    mousePos.y = e.clientY - rect.top - rect.height / 2;
    startRaf();
  });

  section.addEventListener('mouseleave', () => {
    mousePos.x = 0;
    mousePos.y = 0;
    startRaf();
  });

  // Staggered reveal via IntersectionObserver
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // if (isMobile()) {
        //   items.forEach(item => item.classList.add('visible'));
        // } else {
          isVisible = true;
          items.forEach((item, i) => {
            setTimeout(() => item.classList.add('visible'), i * 120);
          });
          startRaf();
        // }
        revealObserver.disconnect();
      }
    });
  }, { threshold: 0.2 });

  revealObserver.observe(section);
})();
